import React from "react";
import { FormGroup, FormGroupProps } from "@blueprintjs/core";

/**
 * FormGroupWithRequired
 * @param props
 * @returns
 */
export const FormGroupWithRequired: React.FC<
	React.PropsWithChildren<
		FormGroupProps & {
			readonly required?: boolean;
		}
	>
> = (props) => {
	const { required, label, ...otherProps } = props;

	return (
		<FormGroup
			{...otherProps}
			label={
				required ? (
					<span>
						<span className='uk-text-danger' title='Required'>
							*{" "}
						</span>
						{label}
					</span>
				) : (
					label
				)
			}
		>
			{props.children}
		</FormGroup>
	);
};
